export const BoardDuplicate = () => {
    return (
        <svg aria-hidden="true" viewBox="0 0 48 48" fill="currentColor">
            <path d="M11 11H20.5V33H11V11Z" />
            <path d="M23.5 33V11H33V33H23.5Z" />
            <path d="M36 20V36H20V40H40V20H36Z" />
        </svg>
    );
};
